// extracted by mini-css-extract-plugin
export default {"label":"c_RKb1uSg","inSearchResult":"cdO4lVz5c"};